var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      staticClass: "app-container",
    },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "140px" },
              attrs: {
                disabled: _vm.$store.state.user.info.area,
                placeholder: "Chọn khu vực",
              },
              on: { change: _vm.getData },
              model: {
                value: _vm.listQuery.areaId,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "areaId", $$v)
                },
                expression: "listQuery.areaId",
              },
            },
            _vm._l(_vm.areas, function (area) {
              return _c("el-option", {
                key: area.id,
                attrs: { label: area.name, value: area.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "", stripe: "" } },
        [
          _c("el-table-column", { attrs: { type: "index" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Loại" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(_vm._s(_vm.PARAMS[row.param]))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Giá trị", prop: "value" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.checkParamsIsHasContent(row.param)
                      ? _c("div", {
                          staticClass: "value-box",
                          domProps: { innerHTML: _vm._s(row.content) },
                        })
                      : _c("div", {
                          domProps: { innerHTML: _vm._s(row.value) },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Hành động" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v("Cập nhật")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "800px",
            id: "config-dialog",
            title: _vm.dialogStatus == "edit" ? "Cập nhật" : "Thêm",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              ref: "form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Loại", prop: "param" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.param,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "param", $$v)
                                },
                                expression: "formData.param",
                              },
                            },
                            _vm._l(_vm.PARAMS, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item, value: index },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isUploadImage
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Giá trị", prop: "value" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.value,
                                    expression: "formData.value",
                                  },
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: {
                                      alias: "decimal",
                                      groupSeparator: ".",
                                      rightAlign: false,
                                      autoGroup: true,
                                      repeat: 20,
                                      autoUnmask: true,
                                      allowMinus: false,
                                    },
                                    expression:
                                      "{\n                alias: 'decimal',\n                groupSeparator: '.',\n                rightAlign: false,\n                autoGroup: true,\n                repeat: 20,\n                autoUnmask: true,\n                allowMinus: false\n              }",
                                  },
                                ],
                                attrs: { type: "text" },
                                domProps: { value: _vm.formData.value },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formData,
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm.isContentUseTiny
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Mô tả", prop: "content" } },
                            [
                              _c("Tinymce", {
                                ref: "editor",
                                attrs: { width: "100%", height: 400 },
                                model: {
                                  value: _vm.formData.content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "content", $$v)
                                  },
                                  expression: "formData.content",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "thumbnail" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    name: "file",
                                    accept: "image/jpeg, image/png",
                                    drag: "",
                                    "before-upload": _vm.beforeUpload,
                                    action:
                                      _vm.$uploadUrl +
                                      "/foods/upload/thumbnail",
                                    "on-success": _vm.handleUploadSuccess,
                                    "show-file-list": false,
                                    headers: {
                                      token: _vm.token,
                                      version: _vm.$version,
                                    },
                                  },
                                },
                                [
                                  !_vm.tempData.thumbnail
                                    ? [
                                        _c("i", {
                                          staticClass: "el-icon-upload",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "el-upload__text" },
                                          [
                                            _vm._v(
                                              "\n                  Kéo thả vào đây hoặc\n                  "
                                            ),
                                            _c("em", [
                                              _vm._v("click vào để upload"),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    : _c("img", {
                                        staticClass: "avatar",
                                        attrs: {
                                          src: _vm.$url(_vm.tempData.thumbnail),
                                          alt: "",
                                        },
                                      }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Đóng")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingButton },
                  on: {
                    click: function ($event) {
                      return _vm.editData()
                    },
                  },
                },
                [_vm._v("Đồng ý")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }